import { useCallback, useEffect, useState } from "react";
import { Data, barChartData } from "../../utils/Data";
import PageHeader from "../../components/common/pageHeader/PageHeader";
import Wrapper from "../../components/utils/Wrapper";
import LineChart from "../../components/common/charts/LineChart";
import BarChart from "../../components/common/charts/BarChart";
import colorArray, {
  mediaLineColorArray,
  overviewTileLineColorArray,
} from "../../utils/JSON/colorArray";
import DonutChart from "../../components/common/charts/DonutChart";
import GeoChart from "../../components/common/charts/GeoChart";
import { ValueCard } from "../../components/common/tiles/ValueCard";
import Table from "../../components/common/charts/TableChart";
import {
  tableColumns1,
  tableColumns,
  tableData,
} from "../../utils/JSON/tableData";
import { countryDataArray } from "../../utils/JSON/countryArray";
import SectionHeading from "../../components/common/SectionHeading";
import useScreenHook from "../../utils/helperFunctions/useScreenHook";
import useOverviewGraphHook from "../../hooks/useOverviewGraphHook";
import { DateRangeObj } from "../../utils/helperFunctions/useDateFilter.js";
import AreaChart from "../../components/common/charts/AreaChart";
import LoadingComponent from "../../components/common/LoadingComponent";
import { useNavigate } from "react-router-dom";
const initialData = {
  labels: Data.map((data) => data.year),
  datasets: [
    {
      label: "Users Gained ",
      data: Data.map((data) => data.userGain),
      backgroundColor: [
        "rgba(75,192,192,1)",
        "#ecf0f1",
        "#50AF95",
        "#f3ba2f",
        "#2a71d0",
      ],
      borderColor: "red",
      borderWidth: 2,
      tension: 0.2,
      pointRadius: 0,
      pointBorderColor: "blue",
      pointBorderWidth: 1,
      showLine: true,
    },
  ],
  scales: {
    x: {
      display: true, // Hide x-axis
      grid: {
        display: true,
      },
      ticks: {
        display: true, // Hide tick marks
      },
      barPercentage: 0.5, // Adjust bar width
      categoryPercentage: 1.5, // Adjust space between bars
    },
    y: {
      display: true, // Hide y-axis
      grid: {
        display: true,
      },
      ticks: {
        display: true, // Hide tick marks
      },
    },
  },
};

const overviewTilesChartData = Data.map((data) => ({
  x: data.year,
  y: data.userGain,
}));

const overviewTilesData = [
  {
    chartData: overviewTilesChartData,
    heading: "Total Published",
    subHeading: "4296",
    description: "published news ",
    customStyle: {
      background:
        "linear-gradient(215.85deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%)",
      line: overviewTileLineColorArray[0],
    },
  },
  {
    chartData: overviewTilesChartData,
    heading: "Total Audience",
    subHeading: "9.2M",
    description: "traffic / circulation / views ",
    customStyle: {
      background:
        "linear-gradient(215.85deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%)",
      line: overviewTileLineColorArray[1],
    },
  },
  {
    chartData: overviewTilesChartData,
    heading: "Media Value (AVE)",
    subHeading: "$235.9K",
    description: "pr value ",
    customStyle: {
      background:
        "linear-gradient(215.85deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%)",
      line: overviewTileLineColorArray[2],
    },
  },
  {
    chartData: overviewTilesChartData,
    heading: "ROI",
    subHeading: "23.9%",
    description: "return on investment ",
    customStyle: {
      background:
        "linear-gradient(215.85deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%)",
      line: overviewTileLineColorArray[3],
    },
  },
];

const sentimentScoreData = {
  data: Data,
  chartSetting: [
    {
      dataKey: "positive",
      label: "positive",
      lineColor: colorArray[3],
      dotColor: colorArray[4],
    },
    {
      dataKey: "neutral",
      label: "neutral",
      lineColor: colorArray[1],
      dotColor: colorArray[4],
    },
    {
      dataKey: "negative",
      label: "negative",
      lineColor: colorArray[0],
      dotColor: colorArray[1],
    },
  ],
  defaultLegend: "positive",
  unit: "Sentiment",
  customeStyle: {
    legendStyle: {
      radioGroupSpace: {
        gap: "47px",
        justifyContent: "center",
      },
    },
  },
};

const mediaValueData = {
  data: barChartData,
};

// interface TableData {
//   promotion: string;
//   posts: string;
//   emv: string;
//   "share of value": string;
// }
interface digitalPublicationsdata {
  name: string;
  mentions: number;
  AVE: number;
  Share: string;
  countryCounts: any;
}

interface GraphDataItem {
  pubDate: string;
  sentiment_counts: any;
}
interface GraphDataItemResult {
  pubDate: string;
  neutral: any;
  positive: any;
  negative: any;
}
//const data: TableData[] = tableData;
const columns = tableColumns;
const columns1 = tableColumns1;

// const geoMapData = {
//   data: countryDataArray,
//   options: {
//     colorAxis: { colors: ["#CBDAF2", "#97B4E6", "#658BCB", "#2F69CC"] },
//   },
// };
interface GraphDataItem {
  pubDate: string;
  totalNoOfArticles: number;
  totalAve: number;
}
export default function Overview() {
  const [chartData, setChartData] = useState(initialData);
  const navigate = useNavigate();

  ///for data
  const [digitalFilter, setDigitalFilter] = useState<DateRangeObj | undefined>(
    undefined
  );
  const [graphData, setGraphData] = useState<GraphDataItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sentimentDataLocal, setSentimentDataLocal] = useState<
    GraphDataItemResult[]
  >([]);
  const {
    graphdata,
    language,
    cartdata1,
    blackcart,
    sentimentData,
    linechart,
    NewsMediaPublicationShares,
    digitalPublicationsdata,
    loading,
    coloredTilesChart,
  }: any = useOverviewGraphHook(digitalFilter);

  const trendsData = {
    data: linechart,
    chartSetting: [
      {
        dataKey: "printNoOfArticles",
        label: "print",
        lineColor: colorArray[0],
        dotColor: colorArray[5],
      },
      {
        dataKey: "digitaltvNoOfArticles",
        label: "digital",
        lineColor: colorArray[1],
        dotColor: colorArray[5],
      },
      {
        dataKey: "tvNoOfArticles",
        label: "tV News",
        lineColor: colorArray[2],
        dotColor: colorArray[5],
      },
      {
        dataKey: "radioNoOfArticles",
        label: "radio/podcast",
        lineColor: colorArray[3],
        dotColor: colorArray[5],
      },
    ],
    unit: "legend",
    defaultLegend: "digitaltvNoOfArticles",
    customeStyle: {
      legendStyle: {
        radioGroupSpace: {
          gap: "65px",
          justifyContent: "center",
        },
      },
    },
  };
  const aveTrendsData = {
    data: linechart,
    chartSetting: [
      {
        dataKey: "printtotalAve",
        label: "print",
        fill: colorArray[0],
        dotColor: colorArray[5],
      },
      {
        dataKey: "digitaltotalAve",
        label: "digital",
        fill: colorArray[1],
        dotColor: colorArray[5],
      },
      {
        dataKey: "tvTotalAve",
        label: "tv News",
        fill: colorArray[2],
        dotColor: colorArray[5],
      },
      {
        dataKey: "radioTotalAve",
        label: "radio/podcast",
        fill: colorArray[3],
        dotColor: colorArray[5],
      },
    ],
    stackedMode: true,
  };
  const fetchDigitalData = useCallback(async () => {
    const currentDate = new Date();
    const startDate = new Date(currentDate);
    startDate.setDate(currentDate.getDate() - 30);
    const endDate = new Date(currentDate);
    let crawlerType = "alltable";
    const dateType = "date";

    setDigitalFilter({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      crawlerType,
      dateType,
    });
  }, [setDigitalFilter]);

  useEffect(() => {
    fetchDigitalData();
  }, [fetchDigitalData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data: GraphDataItem[] = graphdata.map((item: GraphDataItem) => ({
          pubDate: item.pubDate,
          totalNoOfArticles: item.totalNoOfArticles,
          totalAve: item.totalAve,
        }));
        setGraphData(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [digitalFilter, graphdata]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data: GraphDataItemResult[] = sentimentData.map(
          (item: GraphDataItem) => ({
            pubDate: item.pubDate,
            neutral: item.sentiment_counts?.neutral,
            positive: item.sentiment_counts?.positive,
            negative: item.sentiment_counts?.negative,
          })
        );
        setSentimentDataLocal(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [sentimentData]);

  const handleDateRangeChange = (dateRangeObj: DateRangeObj) => {
    setDigitalFilter(dateRangeObj);
  };
  const { deviceType = "desktop" } = useScreenHook();
  interface CountryData {
    country: string;
    count: number;
  }
  interface DigitalPublication {
    countryCounts: { country: string; count: number }[];
  }

  // Ensure digitalPublicationsdata[0] is defined and has countryCounts
  const countryCounts = (digitalPublicationsdata[0] as DigitalPublication)
    ?.countryCounts;

  // Function to transform data into GeoChart format
  const transformData = (
    dataArray: { country: string; count: number }[] | undefined
  ) => {
    const transformedData: any[][] = [["Country", "Published"]]; // Assuming any[][] for simplicity

    // Check if dataArray is defined and not null
    if (dataArray) {
      dataArray.forEach((item) => {
        transformedData.push([item.country, item.count]);
      });
    }

    return transformedData;
  };

  // Now you can use transformData with countryCounts
  const geoMapData = {
    data: transformData(countryCounts),
    options: {
      colorAxis: { colors: ["#CBDAF2", "#97B4E6", "#658BCB", "#2F69CC"] },
    },
  };

  interface DigitalDataItem {
    pubDate: string;
    totalAve: number;
    ave: number;
    digitalNoOfArticles?: number;
    radioNoOfArticles?: number;
    tvNoOfArticles?: number;
    languages: { [key: string]: number };
    sourceNames: { [key: string]: number };
  }
  // Transform digital data for the graph
  // Default placeholder data
  const defaultData = [{ x: "2024-01-01", y: 0 }];

  // Transform data for the graph
  const overviewTilesChartData = (coloredTilesChart as any)?.print?.length
    ? (coloredTilesChart as any)?.print?.map((item: DigitalDataItem) => ({
        x: item.pubDate,
        y: item.ave,
      }))
    : defaultData;

  const overviewTilesChartData1 = (coloredTilesChart as any)?.digital?.length
    ? (coloredTilesChart as any)?.digital?.map((item: DigitalDataItem) => ({
        x: item.pubDate,
        y: item.ave,
      }))
    : defaultData;

  const overviewTilesChartData2 = (coloredTilesChart as any)?.radio?.length
    ? (coloredTilesChart as any)?.radio?.map((item: DigitalDataItem) => ({
        x: item.pubDate,
        y: item.ave,
      }))
    : defaultData;

  const overviewTilesChartData3 = (coloredTilesChart as any)?.tv?.length
    ? (coloredTilesChart as any)?.tv?.map((item: DigitalDataItem) => ({
        x: item.pubDate,
        y: item.ave,
      }))
    : defaultData;

  // Media tiles data configuration
  const mediaTilesData = [
    {
      chartData: overviewTilesChartData,
      heading: "Print",
      subHeading: "$23.9M",
      description: "pr value ",
      path: "/dashboard/print",
      customStyle: {
        background: "linear-gradient(72.11deg, #D52800 0%, #FF0000 100%)",
        line: mediaLineColorArray[0],
      },
    },
    {
      chartData: overviewTilesChartData1,
      heading: "Digital",
      subHeading: "$23.9M",
      description: "pr value ",
      path: "/dashboard/digital",
      customStyle: {
        background: "linear-gradient(72.11deg, #F49600 0%, #FFB338 100%)",
        line: mediaLineColorArray[1],
      },
    },
    {
      chartData: overviewTilesChartData3 ,
      heading: "TV News",
      subHeading: "$23.9M",
      description: "pr value ",
      path: "/dashboard/tv",
      customStyle: {
        background: "linear-gradient(252.11deg, #3C7BE6 0%, #0048C2 100%)",
        line: mediaLineColorArray[2],
      },
    },
    {
      chartData:  overviewTilesChartData2,
      heading: "Radio / Podcast",
      subHeading: "$23.9M",
      description: "pr value ",
      path: "/dashboard/radio",
      customStyle: {
        background: "linear-gradient(35.85deg, #129219 0%, #06CD11 100%)",
        line: mediaLineColorArray[3],
      },
    },
  ];

  if (loading) return <LoadingComponent />;

  return (
    <>
      {/* Heading section */}
      <PageHeader
        heading="Media Monitoring Overview"
        page="alltable"
        onDateRangeChange={handleDateRangeChange}
      />
      {/* tiles section  */}
      <div className="w-full flex overflow-auto gap-3  mt-3 items-center ">
        {overviewTilesData.map((item, index) => (
          <ValueCard
            data={item.chartData}
            title={item.heading}
            value={index ? blackcart[index] : parseInt(blackcart[index])}
            remark={item.description}
            color={item.customStyle}
            hideInsight={false}
          />
        ))}
      </div>
      <div className="w-full flex overflow-auto gap-3  mt-3 items-center ">
        {mediaTilesData.map((item, index) => (
          <ValueCard
            data={item.chartData}
            title={item.heading}
            value={
              cartdata1 && cartdata1.length > index
                ? String(cartdata1[index])
                : "0"
            }
            remark={item.description}
            color={item.customStyle}
            hideInsight={false}
            onClick={() => {
              navigate(item.path);
            }}
          />
        ))}
      </div>
      {/* Trend graphs */}
      <Wrapper customClass={"mt-4 !h-[480px] "}>
        <SectionHeading
          content="Published News Media Trend"
          toolTipText="Tracks the number of published articles across print, digital, tv news, and radio/podcasts, revealing trends and peaks in media activity over time."
        />
        <LineChart rawData={trendsData} />
        {/* {!isLoading && <LineChart rawData={{ data: linechart,
           chartSetting: [{ dataKey: "totalNoOfArticles",  lineColor: colorArray[1], dotColor: colorArray[4] }],
           defaultLegend: "totalNoOfArticles",
          showLegend: false,  }} />} */}
      </Wrapper>
      {/* Media Value Bar chart */}
      {/* <Wrapper customClass={"mt-4"}>
        <SectionHeading
          content="Total Media Value (AVE) Trend"
          customClass={"mb-6"}
        />
        <BarChart chartData={mediaValueData.data} />
      </Wrapper> */}
      {
        <Wrapper customClass={"mt-4 !h-[484px]"}>
          <SectionHeading
            content="Total Media Value (AVE) Trend"
            customClass={"mb-6"}
            toolTipText="Charts the media value (AVE) of published articles across print, digital, tv news, and radio/podcasts, showcasing fluctuations and key trends over time."
          />
          {!isLoading && <AreaChart rawData={aveTrendsData} />}
        </Wrapper>
      }
      <div className="w-full flex md:flex-row flex-col p-[3px] justify-between overflow-auto gap-4 bg-transparent md:h-[480px] h-auto mt-4">
        {/* News Media Publication Donut Bar chart */}
        <Wrapper customClass={"h-full"}>
          <SectionHeading content="News Media Publication Share" toolTipText="Distribution of published articles across print, digital, tv news, and radio/podcasts, highlighting each medium's contribution to total news output." />
          <DonutChart data={NewsMediaPublicationShares} />
        </Wrapper>
        {/* Sentiment Score chart */}
        <Wrapper customClass={"md:h-full h-[480px]"}>
          <SectionHeading content="Sentiment Score" toolTipText="Sentiment trends in news media coverage to track public perception over time with all forms of media combined." />
          <LineChart
            rawData={{
              data: sentimentDataLocal,
              chartSetting: [
                {
                  dataKey: "positive",
                  label: "positive",
                  lineColor: colorArray[3],
                  dotColor: colorArray[4],
                },
                {
                  dataKey: "neutral",
                  label: "neutral",
                  lineColor: colorArray[1],
                  dotColor: colorArray[4],
                },
                {
                  dataKey: "negative",
                  label: "negative",
                  lineColor: colorArray[0],
                  dotColor: colorArray[1],
                },
              ],
              defaultLegend: "positive",
              unit: "Sentiment",
              customeStyle: {
                legendStyle: {
                  radioGroupSpace: {
                    gap: "15%",
                    justifyContent: "center",
                  },
                },
              },
            }}
          />
        </Wrapper>
      </div>
      <div className="w-full p-[3px] flex flex-col md:flex-row justify-between overflow-auto md:gap-4 gap-0">
        {/* Demographics*/}
        <Wrapper
          customClass={"mt-4 max-w-[680px]"}
          moreInsights={{
            redirect: true,
            path: "../../dashboard/demographics",
          }}
        >
          <SectionHeading content="PR Geography" toolTipText="Distribution of media coverage across different regions, highlighting key markets and geographic trends in news publications.
" />
          <GeoChart data={geoMapData.data} options={geoMapData.options} />
        </Wrapper>
        {/* Languages*/}
        <Wrapper customClass={"mt-4 flex-1 overflow-auto "}>
          <SectionHeading content="Languages" toolTipText="Breakdown of published articles by language, showcasing the most prevalent languages in media coverage." />
          <Table
            columns={columns1}
            data={language.slice(0, 5)}
            color={{
              header: "#2F69CC",
              headerText: "#F5F6FA",
            }}
            grayPagination={false}
            showPagination={false}
            customRowStyle={{
              height: deviceType === "desktop" ? "96px" : null,
            }}
            customCellStyle={{ fontSize: "14px" }}
          ></Table>
        </Wrapper>
      </div>
      {/*Publications */}
      <Wrapper customClass={"mt-4"}>
        <SectionHeading content="Top 10 Publications" toolTipText="List of the most influential media outlets based on article volume, highlighting their impact on overall news coverage.
" />
        <Table
          columns={columns}
          data={digitalPublicationsdata}
          color={{
            header: "#2F69CC",
            headerText: "#F5F6FA",
          }}
          showPagination={false}
        ></Table>
      </Wrapper>
    </>
  );
}